import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchOrders = createAsyncThunk('orders/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/orders', { params });
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to fetch orders');
  }
});

export const fetchOrder = createAsyncThunk('orders/fetchOne', async (id, { rejectWithValue }) => {
  try {
    const { data } = await api.get(`/orders/${id}`);
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Order not found');
  }
});

export const createOrder = createAsyncThunk('orders/create', async (orderData, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/orders', orderData);
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to create order');
  }
});

export const updateOrderStatus = createAsyncThunk('orders/updateStatus', async ({ id, status, note }, { rejectWithValue }) => {
  try {
    const { data } = await api.put(`/orders/${id}/status`, { status, note });
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Failed to update status');
  }
});

const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    orders: [], order: null, total: 0, pages: 0, loading: false, error: null,
  },
  reducers: {
    clearOrder: (state) => { state.order = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => { state.loading = true; })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false; state.orders = action.payload.data;
        state.total = action.payload.total; state.pages = action.payload.pages;
      })
      .addCase(fetchOrders.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchOrder.fulfilled, (state, action) => { state.order = action.payload; })
      .addCase(createOrder.fulfilled, (state, action) => { state.orders.unshift(action.payload); })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        const idx = state.orders.findIndex(o => o._id === action.payload._id);
        if (idx >= 0) state.orders[idx] = action.payload;
        if (state.order?._id === action.payload._id) state.order = action.payload;
      });
  },
});

export const { clearOrder } = orderSlice.actions;
export default orderSlice.reducer;
